import { Attachment } from './attachment.model';

export class CustomFile {
    attachment: Attachment;
    file: File;
    loading?: boolean;

    constructor(attachment: Attachment, file?: File) {
        this.attachment = attachment;
        this.file = file!;
    }
}
